module.exports = __webpack_public_path__ + "static/media/PlatekLogo-1000x1000.e99eb9bd.png";